module.exports = __webpack_public_path__ + "img/pic_1@2x.b1f60baa.png";